export default __webpack_public_path__ + "static/media/panels_image.13bebc44.jpg";